<script setup lang="ts">
// The rounded card of rows (an iOS inset grouped list). It has no margin of its own: put it in a `UiGroup`, which owns the
// spacing. Attributes (`class`, `data-*`) land on the card; `as` picks another element (`dl`, `section`, ...).
withDefaults(defineProps<{ as?: string }>(), { as: 'div' })
</script>

<template>
  <component :is="as" class="ui-list">
    <slot />
  </component>
</template>

<style scoped>
.ui-list {
  border-radius: 12px;
  background: var(--tg-section-bg-color);
  border: 1px solid var(--tg-secondary-bg-color);
  overflow: hidden;
}
</style>
